import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";

const Testimonials = () => {
  let sliderRef = useRef(null);
  const [testimonials, setTestimonials] = useState([]);
  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const handleReview = (rating) => {
    let newRating = parseFloat(rating);
    let start = "";
    do {
      if (newRating < 1) {
        start = `${start}<li>
          <i class="fa-solid fa-star-half"></i>
        </li>` ;
      } else {
        start = `${start}<li>
          <i class="fa-solid fa-star"></i>
        </li>`
      }
      newRating = newRating - 1;
    } while (newRating > 0);
    return start;
  }

  const getTestimonial = () => {
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL}/testimonial?limit=20`,
    }).then(res => {
      setTestimonials(res.data.testimonial);
    }).catch(() => {
    });
  }

  useEffect(() => {
    getTestimonial();
  }, []);

  return (
    <>
      <section className="testimo">
        <Container>
          <Row className="align-items-center">
            <Col xl={3} lg={4}>
              <div className="head-title">
                <div className="sup">Testimonials</div>
                <h2>Why Our <span className="text-gradient">Clients Love Us ?</span></h2>
              </div>
              <div className="d-lg-flex d-none align-items-center gap-4">
                <button className="button blue p-xl-3 p-2 rounded-pill" onClick={previous}>
                  <IconArrowLeft size={50} stroke={2} />
                </button>
                <button className="button blue p-xl-3 p-2 rounded-pill" onClick={next}>
                  <IconArrowRight size={50} stroke={2} />
                </button>
              </div>
            </Col>
            <Col xl={9} lg={8}>
              <div className="slider-container">
                {testimonials?.length > 0 ?
                  <>
                    <Slider
                      ref={slider => {
                        sliderRef = slider;
                      }}
                      {...settings}
                    >
                      {testimonials.map(t => {
                        return (
                          <div className="box">
                            <p>{t.country}</p>
                            <strong>{t.feedback}</strong>
                            <ul className='review' dangerouslySetInnerHTML={{ __html: handleReview(t.review) }}>
                            </ul>
                            <div className="client">
                              <div className="user">
                                <img src={`${process.env.REACT_APP_IMG_BASE_URL}${t.userImage}`} alt="" />
                                <div className="info">
                                  <span>{t.userName}</span>
                                  <small>{t.designation}</small>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </Slider>
                  </>
                  : null}
              </div>
            </Col>
            <Col md={12} className="d-lg-none d-flex justify-content-center mt-4">
              <div className="d-flex align-items-center gap-4">
                <button className="button blue p-1 rounded-pill" onClick={previous}>
                <IconArrowLeft size={50} stroke={2} />
                </button>
                <button className="button blue p-1 rounded-pill" onClick={next}>
                  <IconArrowRight size={50} stroke={2} />
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </section >
    </>
  )
}

export default Testimonials